@if (combination) {
  <div>
    <div>
      {{ combination.bool }}
      <button mat-button (click)="openChangeCombinationDialog()" i18n="change combination@@change_combination">
      Change combination
    </button>
      <button mat-raised-button (click)="openAddConditionDialog()" i18n="add condition@@add_condition">
      Add condition
    </button>
    </div>
    @for (condition of combination.conditions; track condition) {
      <div>
        <div style="margin-left: 2vw; margin-top: 0.5vh">
          @if (condition.type === 'combination') {
            <app-kobo-combination
              [input]="condition"
            ></app-kobo-combination>
          }
          @if (condition.type === 'statement') {
            <app-kobo-statement
              [input]="condition"
            ></app-kobo-statement>
          }
        </div>
      </div>
    }
  </div>
}
